import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75930902"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ConfigRecommendShop home-module-bg guideDom-channel-all-2" }
const _hoisted_2 = { class: "ConfigRecommendShop-header" }
const _hoisted_3 = { class: "ConfigRecommendShop-header-title" }
const _hoisted_4 = {
  key: 0,
  class: "ConfigRecommendShop-shoptab"
}
const _hoisted_5 = { class: "ConfigRecommendShop-window" }

import { reactive, onMounted, watch } from 'vue'
import { t } from '@/plugins/i18n'
import TabSwitchArrow from '@/components/common/TabSwitchArrow.vue'
import ShopWindowCategoryBar from '@/components/common/ShopWindowCategoryBar.vue'
import ShopWindow from '@/components/common/ShopWindow.vue'
import { getConfigRecommendShop, getShopDetail as getShopDetailRes } from '@/apis/shop'
import { useRequest } from '@/util/useLoading'
import { bury } from '@/util/useBury'
import { useSite2Station } from '@/store'


export default /*#__PURE__*/_defineComponent({
  props: {
  context: {
    type: Object,
    default: null
  }
},
  setup(__props) {

const stationCode = useSite2Station()

onMounted(() => {
  getList()
})



const data: any = reactive({
  list: [],
  // 分页对象
  page: {
    currentPage: 1,
    pageSize: 8
  },
  // 当前选中的类目下标
  curCategoryIndex: 0,
  // 当前选中档口的id
  curId: '',
  // 店铺信息
  shopDetail: null
})
watch(() => data.curCategoryIndex, val => {
  if (data.list[val].shopInfoList.length !== 0) {
    data.curId = data.list[val].shopInfoList[0].shopCode
  }
})

watch(() => data.curId, val => {
  getShopDetail(val)
})

// 获取列表
const getList = () => {
  getConfigRecommendShop({ stationCode }).then((res: any) => {
    if (res.code === '0') {
      data.list = res.data
      // 模拟数据
      // data.list[0].shopInfoList[0].shopCode = 'VC-73124'
      // data.list[1].shopInfoList[0].shopCode = 'VC-73206'

      if (data.list.length !== 0 && data.list[0].shopInfoList.length !== 0) {
        data.curId = data.list[0].shopInfoList[0].shopCode
        getShopDetail(data.curId)
      }
    }
  })
}

// 获取店铺信息
const [detailLoading, getShopDetail] = useRequest((shopCode: any) => {
  const formData = {
    shopCode,
    pageNum: data.page.currentPage,
    pageSize: data.page.pageSize,
    footprint: false // 不记录足迹
  }
  return getShopDetailRes(formData).then((res: any) => {
    if (res.code === '0') {
      data.shopDetail = {
        ...res.data.supplierRespDTO,
        recommendProductList: res.data.productPage.records
      }
    } else if (res.code === '24100006') {
      for (const item of data.list) {
        for (const it of item.shopInfoList) {
          if (it.shopCode === shopCode) {
            data.shopDetail = {
              ...it
            }
          }
        }
      }
    }
  })
})

// category选中
const categorySelected = (index: any) => {
  data.curCategoryIndex = index
}

// tab选中
const tabSelected = (id: any, item: any) => {
  data.curId = id
}


return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('担当推荐店铺（含档口）')), 1),
      _createVNode(ShopWindowCategoryBar, {
        list: _unref(data).list,
        curIndex: _unref(data).curCategoryIndex,
        "onUpdate:selected": categorySelected
      }, null, 8, ["list", "curIndex"])
    ]),
    (_unref(data).list.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(TabSwitchArrow, {
            list: _unref(data).list[_unref(data).curCategoryIndex].shopInfoList,
            curId: _unref(data).curId,
            "onUpdate:selected": tabSelected
          }, null, 8, ["list", "curId"])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      (_unref(data).shopDetail)
        ? (_openBlock(), _createBlock(ShopWindow, {
            key: 0,
            item: _unref(data).shopDetail
          }, null, 8, ["item"]))
        : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: _unref(t)('店铺不存在')
          }, null, 8, ["description"]))
    ], 512), [
      [_directive_loading, _unref(detailLoading)]
    ])
  ]))
}
}

})